import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { httpPost } from "../../../../common/httpCall";
import { ModalBody, ModalFooter } from "application/modal";
import styles from "modules/projects/project/manageProject/details/details.module.scss";
import PlantMultiSelect from "../../../../common/components/plantMultiselect";
import PlantSelectWithOptions from "../../../../common/components/FordPossibleReplications/plantSelectWithOptions";
import { Link } from "react-router-dom";
import { Icon, smSize } from "../../../../common/icon";
import { PLANT_STATUSES } from "../../../../common/components/FordPossibleReplications/constants";
import { Field, Formik } from "formik";
import { BtnType, Button, Label, MultiSelect, TextBox, TextArea } from "modules/primitives";
import LoadingComponent from "modules/primitives/loading/loading.component";
import { AIScoutFormModel } from "modules/tractionAI/screens/scout/constants";
import TypingText from "modules/tractionAI/components/typingText";

const TractionAIScout = () => {
  const dispatch = useDispatch();

  const [fetchingRes, setFetchingRes] = useState(false);
  const [response, setResponse] = useState(null);

  const {
    authReducer: { session },
    councilReducer: { selectedCouncil },
  } = useSelector((state) => state);

  const handleOptionSelect = prompt => {
    setFetchingRes(true);
    httpPost({
      call: 'ai/proxy/endpoints',
      data: {
        endpoint: "recommend",
        prompt,
      }
    }).subscribe(res => {
      if (res.response.body) {
        setResponse(res.response.body)
      }
      console.log('res', res);
      setFetchingRes(false);
    });
  }

  return (
    <div>
      <div className="mb-3 mt-3">
        <TypingText
          text={'Traction AI: “Please answer the following questions in as much detail as possible. The more information you provide, the better my answers will be.”'}
          speed={50}
        />
      </div>
      <Formik
        // innerRef={formRef}
        initialValues={AIScoutFormModel}
        enableReinitialize
        onSubmit={() => {}}
      >
        {(formikprops) => (
          <>
            <Label>What is the problem you are trying to solve?</Label>
            <div className="w-100">
              <TextArea
                className="w-100"
                placeholder="What is the problem you are trying to solve?"
                formProps={formikprops}
                name="problem"
              />
            </div>
            <Label>What are your business and technical requirements?</Label>
            <div className="w-100">
              <TextArea
                className="w-100"
                placeholder="What are your business and technical requirements?"
                formProps={formikprops}
                name="requirements"
              />
            </div>
          </>
        )}
      </Formik>
    </div>
  );
};

export default React.memo(TractionAIScout);
